"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'myHub';
exports.FETCH_CONTENT = exports.namespace + "/FETCH_CONTENT";
exports.FETCH_RAIL = exports.namespace + "/FETCH_RAIL";
//# sourceMappingURL=constants.js.map